import React from 'react';
import PropTypes from 'prop-types';
import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import {
  Icon,
  BtnGrey32
} from '../../../../components/common/Elements/Elements';

import classes from './TooltipAlert.module.scss';

const TooltipAlert = ({ redactor = false, onClickEdit }) => {
  const language = useUserState().user.language;

  return (
    <div className={classes.tooltipAlert}>
      <div className={classes.info}>
        <div className={classes.iconWrap}>
          <Icon icon="Icn_Info-2" className={classes.icon} />
        </div>
        <div className={classes.text}>
          <p className={classes.topParagraf}>
            {redactor
              ? t('tooltipAlert', 'REDACTOR', language)
              : t('tooltipAlert', 'DONT_PUBLISHED', language)}
          </p>
          {redactor
            ? t('tooltipAlert', 'LESS_TEXT', language)
            : t('tooltipAlert', 'SAVE_TEXT', language)}
        </div>
      </div>
      {redactor && (
        <BtnGrey32
          onClick={onClickEdit}
          textButton={t('widgetReleaseWithRedactor', 'EDIT', language)}
          className={classes.editButton}
        />
      )}
    </div>
  );
};

TooltipAlert.propTypes = {
  redactor: PropTypes.bool,
  onClickEdit: PropTypes.func
};

export default TooltipAlert;
